import { render, staticRenderFns } from "./SearchNexoMemberHeader.vue?vue&type=template&id=386a4cc8&"
import script from "./SearchNexoMemberHeader.vue?vue&type=script&lang=js&"
export * from "./SearchNexoMemberHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchNexoMemberHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports